<template>
  <div
    v-if="tradeIn || mobilePlan"
    class="bg-surface-default-mid flex flex-col gap-16 p-40 pt-24"
  >
    <h2 class="text-static-default-mid body-2">
      {{ i18n(translations.goodToKnow) }}
    </h2>
    <ul class="flex flex-col gap-12">
      <li v-if="tradeIn">
        <NavMenuSidebarItem
          :description="tradeIn.description"
          :icon="IconSwap"
          :title="tradeIn.title"
        />
      </li>
      <li v-if="mobilePlan">
        <NavMenuSidebarItem
          :description="mobilePlan.description"
          :icon="IconSparkles"
          :title="mobilePlan.title"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconSparkles } from '@ds/icons/IconSparkles'
import { IconSwap } from '@ds/icons/IconSwap'

import translations from './NavMenu.translations'
import NavMenuSidebarItem from './NavMenuSidebarItem.vue'

defineProps<{
  tradeIn?: { title: string; description: string }
  mobilePlan?: { title: string; description: string }
}>()
const i18n = useI18n()
</script>
